import { createContext, FC, PropsWithChildren, ReactElement, RefObject, useContext, useRef } from 'react';

interface GameGridContextType {
  refs: {
    contentRef: RefObject<HTMLDivElement>;
    leftControlsRef: RefObject<HTMLDivElement>;
    wideChipStackRef: RefObject<HTMLDivElement>;
    gameGridWrapperRef: RefObject<HTMLDivElement>;
  };
};

const GameGridContext = createContext<GameGridContextType>({
  refs: {
    contentRef: { current: null },
    leftControlsRef: { current: null },
    wideChipStackRef: { current: null },
    gameGridWrapperRef: { current: null },
  },
});

export const GameGridContextProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const contentRef = useRef<HTMLDivElement>(null);
  const leftControlsRef = useRef<HTMLDivElement>(null);
  const wideChipStackRef = useRef<HTMLDivElement>(null);
  const gameGridWrapperRef = useRef<HTMLDivElement>(null);

  return (
    <GameGridContext.Provider
      value={{
        refs: {
          contentRef,
          leftControlsRef,
          wideChipStackRef,
          gameGridWrapperRef,
        },
      }}
    >
      {children}
    </GameGridContext.Provider>
  );
};

export const useGameGridContext = (): GameGridContextType => {
  return useContext(GameGridContext);
};
